/* eslint-disable eqeqeq */
import React from 'react'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import styled from 'styled-components'

interface HeaderProps {
  data?: any
  type?: 'sip' | 'kontrak' | 'so'
}

const StyledProne = styled.div`
  p {
    margin-bottom: 1rem !important;
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
`

export const Header: React.FC<HeaderProps> = (props) => {

  const convertToRoman = (num: number): string => {
    const romanNumerals: { [key: string]: number } = {
        M: 1000,
        CM: 900,
        D: 500,
        CD: 400,
        C: 100,
        XC: 90,
        L: 50,
        XL: 40,
        X: 10,
        IX: 9,
        V: 5,
        IV: 4,
        I: 1,
    };
  
    let roman = '';
    for (let key in romanNumerals) {
        const value = romanNumerals[key];
        while (num >= value) {
            roman += key;
            num -= value;
        }
    }
  
    return roman;
  }
  
  const getDescription = () : string => {
    if (props?.data?.revisi_count) {
        if (props?.data?.regardingSIP == 'SI002') {
            return `Ke-${convertToRoman(props?.data?.revisi_count)}`
        } else {
            return `Revisi ${convertToRoman(props?.data?.revisi_count)}`
        }
    } else return '-'
  }

  const approvedDate = () => {
    let _dt = props.data?.approvedDate ? new Date(props.data?.approvedDate) : new Date();
    return _dt.toLocaleDateString((props.data?.lang == 'en' ? 'en-EN' : 'id-ID'), {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  }

  return (
    <>
      {props.type == 'sip' ? (
        <>
          <div className='text-center'>
            <img src={toAbsoluteUrl(`/media/copSIP.png`)} style={{width: 300}} alt='media' />
            <h1 className='text-decoration-underline mt-4'>
              {props?.data?.regardingSIPDesc ? props?.data?.regardingSIPDesc : (
                'Surat Informasi Penjualan ' + (props?.data?.sector == 3 ? 'Ekspor' : 'Dalam Negeri')
              )}
            </h1>
            {(!['', 0, '0', undefined].includes(props?.data?.revisi_count)) && (
              <h2 className='text-decoration-underline'>
                {getDescription()}
              </h2>
            )}
            <p className='mt-1'>No. {props?.data?.noSIP ? ('11' + props?.data?.noSIP) : ''}</p>
            <p>Jakarta, {props?.data?.tanggalApprove}</p>
          </div>
          <div className='mt-4'>
            <p>Kepada Yth,</p>
            <p>{props.data.kepada}</p>
            <b>{props.data.produsen}</b>
            <p>di Tempat</p>
          </div>
          <div className='mt-4'>
            <p style={{textAlign: 'justify'}}>
              {/* Menindaklanjuti hasil negosiasi yang telah dilakukan antara PT Pupuk Indonesia
              (Persero) dengan {props.data.customer} melalui surat ini kami informasikan poin-poin
              pokok hasil kesepakatan sebagai berikut: */}
              {<StyledProne dangerouslySetInnerHTML={{__html: props.data?.bodyContent}} />}
            </p>
          </div>
        </>
      ) : props.type == 'kontrak' ? (
        <>
          <div className='text-center'>
            <img
              src={toAbsoluteUrl(props?.data?.imgHeader)}
              style={{width: '100%', height: 'auto', objectFit: 'cover'}}
              alt='media'
            />
            <h1 className='text-decoration-underline mt-4'>
              {props.data.lang == 'en' ? (
                <>{props?.data?.has_amendment ? 'REVISED ' : ''}LETTER OF CONFIRMATION</>
              ) : (
                <>
                  {props?.data?.has_amendment ? 'REVISI ' : ''}SURAT KONFIRMASI PERSETUJUAN PEMBELIAN
                  <br />
                  (SKPP)
                </>
              )}
            </h1>
            <p className='mt-1'>No. { props.data.sapNumber }</p>
            <p>{ approvedDate() }</p>
          </div>
          <div className='mt-4'>
            {props.data.lang == 'id' && <p>Kepada Yth,</p>}
            <b>{props.data.customer}</b>
            <p style={{
              maxWidth: '230px'
            }}>{props.data.address}</p>
            {props.data.sector != 3 || props.data.sector != '3' ? (
              <>
                <p>{props.data.city}</p>
                <p>{props.data.region}</p>
              </>
            ) : (
              <p>{props.data.region}</p>
            )}
            {
              props.data.customerAttn && <>
                <b>
                  Attn. { props.data.customerAttn }
                </b>
                <br />
              </>
            }
            <br />
            {/* <p>
              {props.data.lang == 'en' ? 'Dear Sir/Madam' : 'Dengan Hormat'},{' '}
              {props.data.customerAttn}
            </p>
            <br /> */}

            <p>
              {props.data?.lang == 'en' ? (
                'Dear Sir/Madam,'
              ) : (
                'Dengan Hormat,'
              )}
            </p>

            <br />

            {props?.data?.mail && (
              <p>
                <StyledProne dangerouslySetInnerHTML={{__html: props.data.mail}} />
              </p>
            )}
            {/* {props.data.lang == 'en' ? (
                            <p>We hereby confirm to sell product under the following terms and conditions :</p>
                        ) : (
                            <p>Bersama ini kami sampaikan persetujuan alokasi pembelian dengan rincian sebagai berikut :</p>
                        )} */}
          </div>
        </>
      ) : props.type == 'so' ? (
        <>
          <img
            src={toAbsoluteUrl(props?.data?.imgHeader)}
            style={{width: '100%', height: 'auto', objectFit: 'cover'}}
            alt='media'
          />
          <div className='text-center'>
            <h1 className='text-decoration-underline mt-4'>SALES ORDER</h1>
            <p className='mt-1'>No. {props.data?.sapNumber}</p>
            <p>{approvedDate()}</p>
          </div>
          <div className='mt-4'>
            {props.data.lang == 'id' && <p>Kepada Yth,</p>}
            <b>{props.data.customer}</b>
            <p style={{
              maxWidth: '230px'
            }}>{props.data.address}</p>
            <p>{props.data?.customerAddress?.city}</p>
            {
              props.data.customerAttn && <>
                <b>
                  Attn. {props.data?.customerAttn.replace(/<\/?[^>]+(>|$)/g, "")}
                </b>
                <br />
              </>
            }
            <br />
            {/* <p>
              {props.data.lang == 'en' ? 'Dear Sir/Madam' : 'Dengan Hormat'},{' '}
              {props.data.customerAttn}
            </p>
            <br /> */}

            <p>
              {props.data?.lang == 'en' ? (
                'Dear Sir/Madam,'
              ) : (
                'Dengan Hormat,'
              )}
            </p>

            <br />
            {props.data.lang == 'en' ? (
              <p>We would like to inform you that we have received your order as follows :</p>
            ) : (
              <p>
                Bersama ini kami sampaikan persetujuan alokasi pembelian dengan rincian sebagai
                berikut :
              </p>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default React.memo(Header)
